// Э-9. Дашборд руководителя: план/факт дня по заводам, выполнение месяца, проблемы, загрузка РБУ,
// отгрузки по часам, % в срок. Работает с телефона.

import { fmtNum, fmtTime } from "../../shared/format";
import { useLive } from "../../shared/live";
import { navigate } from "../../shared/router";
import { TopBar } from "../../shared/shell";
import { Bar, Empty, Kpi, Loading, useAsync, useInterval } from "../../shared/ui";
import { api, live } from "../ctx";

export function DashboardPage() {
  const d = useAsync<any>(() => api.get("/dashboard"), []);
  useLive(live, ["trip.", "order."], () => d.reload(), 1500);
  useInterval(() => d.reload(), 120_000);
  const v = d.data;
  return (
    <>
      <TopBar title={v ? `Сегодня, ${v.date.split("-").reverse().slice(0, 2).join(".")}` : "Сегодня"} />
      <div className="content">
        {!v ? <Loading error={d.error} onRetry={d.reload} /> : (
          <>
            <div className="kpis">
              <Kpi k="Отгружено" v={`${fmtNum(v.shipped_m3, 0)} м³`} s={`из ${fmtNum(v.plan_m3, 0)} по плану`} />
              <Kpi k="План месяца" v={v.month.pct === null ? "—" : `${fmtNum(v.month.pct, 0)}%`} s={`${fmtNum(v.month.fact_m3, 0)} из ${fmtNum(v.month.plan_m3, 0)} м³`} />
              {/* замечание 15.10 №6: средний темп и прогноз на месяц против плана */}
              <Kpi k="Темп и прогноз месяца" v={v.month.pace_m3_day == null ? "—" : `${fmtNum(v.month.pace_m3_day, 0)} м³/сут`}
                tone={v.month.forecast_pct != null && v.month.forecast_pct < 95 ? "warn" : undefined}
                s={v.month.forecast_m3 == null ? "темп появится со второго дня месяца"
                  : `прогноз ${fmtNum(v.month.forecast_m3, 0)} м³${v.month.forecast_pct != null ? ` (${fmtNum(v.month.forecast_pct, 0)}% плана)` : ""}${v.month.need_m3_day ? `; для плана нужно ${fmtNum(v.month.need_m3_day, 0)} м³/сут` : ""}`} />
              <Kpi k="Заявок в работе" v={v.orders_active} s={`на ${v.plants_with_orders} ${v.plants_with_orders === 1 ? "заводе" : "заводах"}`} />
              <Kpi k="Проблемы" v={v.problems_count} s={v.problems_count ? "нужно решение" : "нет"} tone={v.problems_count ? "warn" : undefined} />
              <Kpi k="В срок сегодня" v={v.on_time_today.on_time_pct === null ? "—" : `${fmtNum(v.on_time_today.on_time_pct, 0)}%`}
                s={`за месяц ${v.on_time_month.on_time_pct === null ? "—" : fmtNum(v.on_time_month.on_time_pct, 0) + "%"}`} />
            </div>
            <div className="cols-2">
              <div className="panel">
                <div className="ph"><h2>По заводам</h2></div>
                <div className="pb stack">
                  {v.plants.map((p: any) => (
                    <div key={p.id} className="stack tight">
                      <div className="row between"><span>{p.name}</span><span className="num">{fmtNum(p.fact_m3, 0)} / {fmtNum(p.plan_m3, 0)} м³</span></div>
                      <Bar value={p.fact_m3} max={p.plan_m3 || 1} />
                    </div>
                  ))}
                </div>
              </div>
              <div className="panel">
                <div className="ph"><h2>Требуют внимания</h2></div>
                <div className="pb stack tight">
                  {v.problems.length === 0 && <Empty>Всё идёт по плану.</Empty>}
                  {v.problems.slice(0, 6).map((p: any, i: number) => (
                    <div key={i} className={`alert${p.level === "late" ? " risk" : ""}`} onClick={() => p.order_id && navigate("/schedule", { order: p.order_id })} style={{ cursor: "pointer" }}>
                      <div className="t">{p.text}</div>
                    </div>
                  ))}
                  {v.unit_load.filter((u: any) => u.idle_until).map((u: any) => (
                    <div key={u.unit_id} className="alert">
                      <div className="t">{u.name} простаивает</div>
                      <div className="d">{u.idle_until === "до конца дня" ? "Нет заявок до конца дня" : `Нет заявок до ${fmtTime(u.idle_until)}`}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="panel">
              <div className="ph"><h2>Отгрузки по часам</h2><span className="muted small">столбец — факт, риска — план</span></div>
              <div className="pb"><HourChart data={v.by_hour} /></div>
            </div>
            <div className="panel">
              <div className="ph"><h2>Загрузка РБУ</h2></div>
              <div className="pb stack">
                {v.unit_load.map((u: any) => (
                  <div key={u.unit_id} className="row">
                    <span style={{ width: 160 }}>{u.name}</span>
                    <div className="grow"><Bar value={u.day_pct} warn={u.day_pct > 85} /></div>
                    <span className="num" style={{ width: 60, textAlign: "right" }}>{fmtNum(u.day_pct, 0)}%</span>
                  </div>
                ))}
              </div>
            </div>
            <p className="muted small">Рассылка сводки в Max — на Этапе 4.</p>
          </>
        )}
      </div>
    </>
  );
}

function HourChart({ data }: { data: { hour: number; fact_m3: number; plan_m3: number }[] }) {
  const max = Math.max(9, ...data.map((d) => Math.max(d.fact_m3, d.plan_m3)));
  const w = 24 * 28;
  const h = 140;
  return (
    <svg viewBox={`0 0 ${w} ${h + 18}`} style={{ width: "100%", maxWidth: 900 }} role="img" aria-label="Отгрузки по часам, план и факт">
      {data.map((d) => {
        const x = d.hour * 28 + 4;
        const fh = (d.fact_m3 / max) * h;
        const ph = (d.plan_m3 / max) * h;
        return (
          <g key={d.hour}>
            <rect x={x} y={h - fh} width={20} height={fh} rx={3} fill="var(--st-done)" />
            {d.plan_m3 > 0 && <line x1={x - 2} x2={x + 22} y1={h - ph} y2={h - ph} stroke="var(--ink)" strokeWidth={2} />}
            {d.hour % 2 === 0 && <text x={x + 10} y={h + 14} fontSize={11} textAnchor="middle" fill="var(--muted)">{d.hour}</text>}
            <title>{`${d.hour}:00 — факт ${d.fact_m3} м³, план ${d.plan_m3} м³`}</title>
          </g>
        );
      })}
    </svg>
  );
}
